import { Fieldset } from 'primereact/fieldset';
import { InputTextarea } from 'primereact/inputtextarea';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import InputField from '../../../../components/inputField/InputField';
import Pages from '../../../../config/Pages';
import Shareds from '../../../../config/translations/Shareds';
import ConfirmDialog from '../../../../core/components/ConfirmDialog';
import InputTextLengthCounter from '../../../../core/components/inputs/inputTextLengthCounter/InputTextLengthCounter';
import BaseForm from '../../../../core/page/components/baseForm/BaseForm';
import { arrayToDateString } from '../../../../core/utils/DateMixins';
import analisePropostaMetaService from '../../../../service/AnalisePropostaMetaService';
import RadioContainer from '../../indicadorSolicitacoes/components/radioContainer/RadioContainer';
import DadosSolicitacao from '../components/DadosDaSolicitacao';
import LayoutAnaliseMetas from '../components/layoutAnaliseMetas/LayoutAnaliseMetas';
import styles from './AnalisePropostaMetaForm.module.scss';

const inputs = [
    { name: 'flagValidacao', label: 'Validado', form: { use: true, validate: { required: true } } },
    {
        name: 'manifestacao',
        label: 'MANIFESTAÇÃO TÉCNICA',
        form: { use: true, validate: { required: true } },
    },
];

const Inputs = ({ formik, formController, disabled = false }) => {
    return (
        <Fieldset
            className={`${styles.fieldset} p-mt-5`}
            legend={
                <div>
                    Analise Negocial:
                    <span className={styles.required}>*</span>
                </div>
            }
        >
            <div className={`p-grid p-fluid p-col-12 ${styles.containerInputsRadio}`}>
                <div
                    className={`p-grid p-fluid p-col-12 ${styles.noPadding} ${
                        formik.errors?.flagValidacao ? styles.borderRed : ''
                    }`}
                >
                    <div className="p-col-6">
                        <RadioContainer
                            formik={formik}
                            value={true}
                            label="VALIDADO"
                            disabled={disabled || formController.isView()}
                        />
                    </div>
                    <div className="p-col-6">
                        <RadioContainer
                            formik={formik}
                            value={false}
                            label="NÃO VALIDADO"
                            disabled={disabled || formController.isView()}
                        />
                    </div>
                </div>
                {formik.errors?.flagValidacao && (
                    <small className={`${styles.error} p-col-12`}>
                        {formik.errors?.flagValidacao}
                    </small>
                )}
            </div>
            <div className="p-grid p-fluid p-col-12">
                <InputField
                    formik={formik}
                    className={styles.manifestacao}
                    id="manifestacao"
                    label="MANIFESTAÇÃO TÉCNICA:"
                    required
                >
                    <InputTextLengthCounter maxLen={500}>
                        <InputTextarea
                            value={formik.values.manifestacao}
                            onChange={formik.handleChange}
                            disabled={disabled || formController.isView()}
                            rows={4}
                        />
                    </InputTextLengthCounter>
                </InputField>
            </div>
        </Fieldset>
    );
};

function AnalisePropostaMetaForm() {
    const [avaliacao, setAvalicao] = useState({});
    const history = useHistory();
    const formRef = useRef(null);
    const { id } = useParams();
    const confimRef = useRef(null);

    const loadData = useCallback(async () => {
        const { dataCadastro, parecerMeta, descManifestacaoTecnica, ...response } =
            await analisePropostaMetaService.buscarPorId({ id });
        const toDateString = (dt) => {
            return Array.isArray(dt) ? arrayToDateString(dt) : dt;
        };
        setAvalicao({
            ...response,
            dataCadastro: toDateString(dataCadastro),
            meta: {
                ...response?.meta,
                dataPrevisaoApuracao: toDateString(response?.meta?.dataPrevisaoApuracao),
            },
        });
        formRef.current?.setInitialValues({
            id: id ?? null,
            flagValidacao: parecerMeta ?? null,
            manifestacao: descManifestacaoTecnica ?? '',
        });
    }, []);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const podeSalvar =
        avaliacao?.meta?.indicador?.situacaoIndicador?.codgSituacaoIndicador !== 'ATIVO' ||
        avaliacao?.situacaoAvaliacaoMeta?.codgSituacaoAvaliacaoMeta === 'FINALIZADA';

    return (
        <>
            <ConfirmDialog ref={confimRef} />
            <LayoutAnaliseMetas
                indicador={avaliacao?.meta?.indicador ?? {}}
                onVoltar={() => {
                    if (formRef.current?.formController.hasChangeInputs) {
                        confimRef.current.show(Shareds.form.dontSaveData, () => {
                            confimRef.current?.hide();
                            setTimeout(
                                () => history.push(Pages.sei.analisePropostaMeta.url.list),
                                500
                            );
                        });
                    } else {
                        history.push(Pages.sei.analisePropostaMeta.url.list);
                    }
                }}
                onSalvar={() => {
                    formRef.current.formController.addCountClick();
                    formRef.current?.formik.submitForm();
                }}
                disableSalvar={podeSalvar || `${window.location.pathname}`.includes('/view')}
            >
                <DadosSolicitacao
                    dataCadastro={avaliacao?.dataCadastro}
                    contaAcessoCadastro={avaliacao?.contaAcessoCadastro?.nome}
                    meta={avaliacao?.meta ?? {}}
                />
                <BaseForm
                    ref={formRef}
                    page={Pages.sei.analisePropostaMeta}
                    buscarOnLoad={false}
                    onSubmit={analisePropostaMetaService.salvar.bind(analisePropostaMetaService)}
                    initialValues={inputs}
                    prepareInitialValues={async (dados) => ({ ...dados, id })}
                >
                    <Inputs disabled={podeSalvar} />
                </BaseForm>
            </LayoutAnaliseMetas>
        </>
    );
}

export default AnalisePropostaMetaForm;
